import { baseRequest } from '../utils';

export const types = {
  FETCH_WEATHER_ALERTS_REQUEST: 'FETCH_WEATHER_ALERTS_REQUEST',
  FETCH_WEATHER_ALERTS_SUCCESS: 'FETCH_WEATHER_ALERTS_SUCCESS',
  FETCH_WEATHER_ALERTS_ERROR: 'FETCH_WEATHER_ALERTS_ERROR',
  DISMISS_WEATHER_BANNER: 'DISMISS_WEATHER_BANNER',
};

const initialState = {
  hasAlert: false,
  alerts: [],
  locationName: '',
  locations: [],
  loading: false,
  dismissed: false,
};

export const dismissWeatherBanner = () => ({ type: types.DISMISS_WEATHER_BANNER });

export const fetchWeatherAlerts = () => {
  const success = (payload) => ({ type: types.FETCH_WEATHER_ALERTS_SUCCESS, payload });
  const failure = () => ({ type: types.FETCH_WEATHER_ALERTS_ERROR });

  return (dispatch) => {
    dispatch({ type: types.FETCH_WEATHER_ALERTS_REQUEST });
    return baseRequest('GET', '/weather/alerts')
      .then((response) => dispatch(success(response.data)))
      .catch(() => dispatch(failure()));
  };
};

const weatherReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_WEATHER_ALERTS_REQUEST:
      return { ...state, loading: true };
    case types.FETCH_WEATHER_ALERTS_SUCCESS:
      return {
        ...state,
        loading: false,
        hasAlert: action.payload.hasAlert,
        alerts: action.payload.alerts,
        locationName: action.payload.locationName,
        locations: action.payload.locations ?? [],
      };
    case types.FETCH_WEATHER_ALERTS_ERROR:
      return { ...state, loading: false };
    case types.DISMISS_WEATHER_BANNER:
      return { ...state, dismissed: true };
    default:
      return state;
  }
};

export default weatherReducer;
